<template>
  <v-container>
    <h1 class="mb-5">Approved Purchase</h1>
    <user-details-min :userId="minUserId" :open.sync="openMin" />
    <v-row>
      <v-col>
        <v-card flat color="white">
          <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search..."
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :footer-props="{
              itemsPerPageOptions: [5, 10, 15, 25, 50]
            }"
            @update:items-per-page="updateItemPerPage"
            @update:page="updatePage"
            :server-items-length="apiData.total"
            :loading="loadingTransaction"
            :headers="headers"
            :items-per-page="perPage"
            :items="arrangedTransaction"
          >
            <template v-slot:[`item.status`]="{ item }">
              <v-card
                :color="
                  item.status == 'approved'
                    ? 'success'
                    : item.status == 'pending'
                    ? 'warning'
                    : 'error'
                "
                flat
                rounded="md"
                outlined
                class="text-capitalize text-center white--text pa-1"
              >
                {{ item.status }}
              </v-card>
            </template>
            <template v-slot:[`item.buyer`]="{ item }">
              <!-- <router-link
                :to="{ name: 'ViewUser', params: { id: item.buyer_id } }"
                class="font-weight-medium text-capitalize d-block"
                >{{ item.buyer }}</router-link
              > -->
              <span
                class="font-weight-medium cursor-pointer primary--text text-capitalize d-block"
                @click="openMinDialog(item.buyer_id)"
              >
                {{ item.buyer }}
              </span>
            </template>
            <template v-slot:[`item.currency`]="{ item }">
              <span class="font-weight-medium">{{ item.currency }}</span>
            </template>
            <template v-slot:[`item.date`]="{ item }">
              <small class="font-weight-medium">{{ item.date }}</small>
            </template>
            <template v-slot:[`item.price`]="{ item }">
              <span
                >{{ item.price }}
                <small class="grey--text text--darken-2">NGN</small></span
              >
            </template>
            <template v-slot:[`item.amount`]="{ item }">
              <span>
                <span class="grey--text text--darken-2">$</span>
                {{ item.amount }}</span
              >
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <v-btn small depressed @click="selectTransaction(item)"
                >View Details</v-btn
              >
            </template>
          </v-data-table>
          <!-- <delete-dialog :open.sync="dialogDelete" type="purchase" /> -->
          <transaction-details
            :open.sync="transactionOpen"
            :transaction="transaction"
            type="purchase"
          />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// import deleteDialog from '../../../components/deleteDialog.vue'
import TransactionDetails from '../../../components/transactionDetails.vue'
import transactionApi from '../../../api/admin/transactions'
import { numberWithCommas } from '../../../utils/helpers'
import UserDetailsMin from '../../../components/userDetailsMin.vue'
import _ from 'lodash'

export default {
  components: {
    // deleteDialog,
    TransactionDetails,
    UserDetailsMin
  },
  data: () => ({
    openMin: false,
    minUserId: '',
    search: '',
    dialogDelete: false,
    transactionOpen: false,
    headers: [
      {
        text: 'Date',
        align: 'start',
        value: 'date'
      },
      {
        text: 'Buyer',
        sortable: false,
        value: 'buyer'
      },
      {
        text: 'Currency',
        value: 'currency',
        sortable: false
      },
      {
        text: 'Price (NGN)',
        value: 'price'
      },
      {
        text: 'Price (USD)',
        value: 'amount'
      },
      {
        text: 'Status',
        value: 'status'
      },
      {
        text: 'Action',
        value: 'action',
        sortable: false
      }
    ],
    transactions: [],
    selectedTransaction: {},
    transaction: {},
    transactionsM: [],
    perPage: 10,
    loadingTransaction: false,
    apiData: {},
    lastPage: 1
  }),
  created() {
    this.getTransactions(0)
    this.debounceSearch = _.debounce(this.searchData, 500)
  },
  watch: {
    search(newValue) {
      if (newValue === '') {
        this.getTransactions(0)
        return
      }
      this.debounceSearch()
    }
  },
  computed: {
    arrangedTransaction() {
      if (this.transactionsM.length !== []) {
        return this.transactionsM.map((transaction) => ({
          id: transaction._id,
          date: transaction.date_string,
          buyer: transaction.user.username,
          buyer_id: transaction.user._id,
          currency: transaction.coin
            ? transaction.coin.name
            : transaction.currency
            ? transaction.currency.name
            : '',
          status: transaction.status,
          price: numberWithCommas(transaction.main_amo),
          amount: numberWithCommas(transaction.amount)
        }))
      }
      return []
    }
  },
  methods: {
    async searchData() {
      this.loadingTransaction = true
      this.transactionsM = []
      const res = await transactionApi.transactions().getAll({
        type: 'purchase',
        status: 'approved',
        category: 'coin',
        populate: ['user', 'coin', 'currency', 'actionby'],
        limit: this.perPage,
        keyword: this.search
      })
      if (res.error) {
        this.$store.dispatch('alert', {
          message:
            res.errorMessage.message ||
            `${res.internalError.message}, please try again`,
          error: true,
          status: true
        })
        return
      }
      this.transactions = res.data.data.data
      this.transactionsM = res.data.data.data
      this.apiData = res.data.data.meta
      this.loadingTransaction = false
    },
    openMinDialog(id) {
      this.openMin = true
      this.minUserId = id
    },
    updatePage(page) {
      if (this.lastPage - page > 2) {
        page = this.lastPage
      }
      this.lastPage = page
      this.getTransactions((page - 1) * this.perPage)
    },
    updateItemPerPage(count) {
      this.perPage = count
      this.getTransactions((this.lastPage - 1) * this.perPage)
    },
    async getTransactions(length) {
      this.loadingTransaction = true
      const res = await transactionApi.transactions().getAll({
        type: 'purchase',
        status: 'approved',
        category: 'coin',
        populate: ['user', 'coin', 'currency', 'actionby', 'method'],
        limit: this.perPage,
        offset: length
      })
      if (res.error) {
        this.$store.dispatch('alert', {
          message:
            res.errorMessage.message ||
            `${res.internalError.message}, please try again`,
          error: true,
          status: true
        })
        return
      }
      this.transactions = res.data.data.data
      this.transactionsM = res.data.data.data
      this.apiData = res.data.data.meta
      this.loadingTransaction = false
    },
    selectTransaction(transx) {
      const transaction = this.transactions.find((trx) => trx._id === transx.id)

      this.transaction = {
        ...transaction,
        image: transaction.image,
        date: transaction.date_string,
        time: transaction.time_string,
        status: transaction.status,
        transactionInfo: [
          {
            title: 'Transaction Type',
            text: `${transaction.type}`
          },
          {
            title: 'Amount',
            text: `${numberWithCommas(transaction.amount)} USD`
          },
          {
            title: 'Cryptocurrency',
            text: `${
              transaction.coin
                ? transaction.coin.name
                : transaction.currency
                ? transaction.currency.name
                : ''
            }`
          },
          {
            title: 'Amount in NGN',
            text: `${numberWithCommas(transaction.price)} NGN`
          },
          {
            title: 'Transaction ID',
            text: `${transaction.trx}`
          },
          {
            title: 'Details',
            text: `${transaction.type} Cryptocurrency`
          }
        ],
        transactionDetails: [
          {
            title: 'Payment Method',
            text: `${transaction.method ? transaction.method.name : ''}`
          },
          {
            title: `Amount Paid by ${transaction.depositor}`,
            text: `${numberWithCommas(transaction.amountpaid)} NGN`
          },
          {
            title: 'Transaction Charge',
            text: `${numberWithCommas(transaction.charge)} NGN`
          },
          // {
          //   title: 'Transfer Fee Charge',
          //   text: `${numberWithCommas(transaction.tcharge)} NGN`
          // },
          {
            title: 'Stamp Duty',
            text: `0 NGN`
          },
          {
            title: `${transaction.coin.symbol} to Receive`,
            text: `${transaction.getamo}`
          },
          {
            title: 'Amount to Credit',
            text: `${numberWithCommas(transaction.amount)} worth of ${
              transaction.coin !== null ? transaction.coin.name : ''
            }`
          },
          {
            title: 'Payment To Wallet',
            text: `${transaction.wallet}`
          },
          {
            title: "Depositor's Name",
            text: `${transaction.depositor ?? transaction.user.username}`
          },
          {
            title: 'Action By',
            text: `${
              transaction.actionby ? transaction.actionby.name : 'admin'
            }`
          },
          {
            title: 'Approved At',
            text: transaction.actionedAt
              ? new Date(transaction.actionedAt)
              : 'No approved date/time provided'
          }
        ]
      }
      this.transactionOpen = true
    }
    // async getATransaction(id) {
    //   const res = await transactionApi.transactions().getSingle(id)
    //   // console.log(res)
    // }
  }
}
</script>

<style></style>
